<p class="session-values" freud-typography fontType="bodyBold1-2">
  <span *ngIf="type === 'particular'">
    {{ particularPrice | currency: 'BRL' }}
  </span>
  <span *ngIf="type === 'corporate'">
    {{ corporatePrices }}
  </span>
  <span style="font-weight: 400">
    &nbsp;| {{ typeLabel }}
  </span>
</p>